import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loader-container" }
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "loader-spinner" }, [
      _createElementVNode("svg", {
        class: "spinner",
        viewBox: "0 0 50 50"
      }, [
        _createElementVNode("circle", {
          class: "path",
          cx: "25",
          cy: "25",
          r: "20",
          fill: "none",
          "stroke-width": "5"
        })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
    ])
  ]))
}